/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloatIconContent } from '../../models/float-icon-content';

export interface ApiMasterHeaderFooterIconGetFloatInfoGet$Params {
}

export function apiMasterHeaderFooterIconGetFloatInfoGet(http: HttpClient, rootUrl: string, params?: ApiMasterHeaderFooterIconGetFloatInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FloatIconContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterHeaderFooterIconGetFloatInfoGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FloatIconContent>;
    })
  );
}

apiMasterHeaderFooterIconGetFloatInfoGet.PATH = '/api/Master/HeaderFooterIcon/GetFloatInfo';
